import axios from 'axios';

const API_BASE = 'https://canvasoft.com:8487/canvamanager';

export interface CartItemRequest {
  idCliente: number;
  idImagen: number;
  secuencia: number;
}

// Convierte URLs absolutas al puerto del backend (:8487) en rutas relativas,
// igual que hace api.ts, para evitar fetch cross-origin al descargar la imagen preview
const normalizeImageUrl = (item: any) => {
  if (item?.url?.startsWith('https://canvasoft.com:8487/')) {
    return { ...item, url: item.url.replace('https://canvasoft.com:8487/', '/') };
  }
  return item;
};

export const cartService = {
  async getCart(idCliente: number) {
    const response = await axios.get(`${API_BASE}/market/cart/${idCliente}`);
    return Array.isArray(response.data) ? response.data.map(normalizeImageUrl) : response.data;
  },

  async addToCart(request: CartItemRequest) {
    const response = await axios.post(`${API_BASE}/market/cart`, null, {
      params: {
        idCliente: request.idCliente,
        idImagen: request.idImagen
      }
    });
    return response.data;
  },

  async updateCart(request: CartItemRequest) {
    const response = await axios.put(`${API_BASE}/market/cart`, null, {
      params: {
        idCliente: request.idCliente,
        idImagen: request.idImagen
      }
    });
    return response.data;
  },

  async removeFromCart(idCliente: number, idImagen: number) {
    await axios.delete(`${API_BASE}/market/cart`, {
      params: { idCliente, idImagen }
    });
  },

  async clearCart(idCliente: number) {
    await axios.delete(`${API_BASE}/market/cart/${idCliente}/clear`);
  }
};